import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadCheckTypesByIdFailed, loadCheckTypesByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadCheckTypesById(action) {
  try {
    const url = `${BACKEND_URL}/resources/check-types/${action.payload}`;
    yield call(resolveActionPromise(action));
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadCheckTypesByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadCheckTypesByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadCheckTypesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
